import { MenuItem } from '@chakra-ui/react'
import colors from 'theme/colors.theme'
import { Token, Width } from 'types/chakra'

interface IDropdownSelectionProps {
  onClick: () => void
  label: string | number | React.ReactNode
  isSelected?: boolean
  width?: Token<Width | number, 'sizes'>
  minWidth?: Token<Width | number, 'sizes'>
  maxWidth?: Token<Width | number, 'sizes'>
  isTable?: boolean
  height?: Token<Width | number, 'sizes'>
  fontSize?: Token<Width | number, 'fontSizes'>
  color?: string
  icon?: React.ReactElement
  children?: React.ReactNode
}

const DropdownSelection = (props: IDropdownSelectionProps) => {
  const { onClick, label, width, minWidth, maxWidth, isTable, height, fontSize, color, icon, children, isSelected } =
    props
  return (
    <MenuItem
      padding="8px 16px"
      width={width ?? { base: '400px', lg: '178px' }}
      minWidth={minWidth}
      maxWidth={maxWidth}
      onClick={onClick}
      className="dropdown-selection"
      background={isSelected ? colors.gray[100] : 'white'}
      borderWidth="0"
      outline="none"
      paddingLeft={isTable ? { base: '45px', md: '16px' } : 4}
      height={height ?? { base: '48px', lg: '40px' }}
      fontSize={fontSize ?? { base: 'lg', lg: 'md' }}
      // justifyContent={{ base: 'center', md: 'flex-start' }}
      whiteSpace="nowrap"
      color={color ?? 'gray.700'}
      icon={icon}
    >
      {children ?? label}
    </MenuItem>
  )
}

export default DropdownSelection
